/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SensorData from './SensorData';

/**
 * The HydroSystemStatusExternals model module.
 * @module model/HydroSystemStatusExternals
 * @version 1.1.0
 */
class HydroSystemStatusExternals {
    /**
     * Constructs a new <code>HydroSystemStatusExternals</code>.
     * @alias module:model/HydroSystemStatusExternals
     * @param sensors {Array.<module:model/SensorData>} Array of external sensors
     */
    constructor(sensors) { 
        
        HydroSystemStatusExternals.initialize(this, sensors);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, sensors) { 
        obj['sensors'] = sensors;
    }

    /**
     * Constructs a <code>HydroSystemStatusExternals</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/HydroSystemStatusExternals} obj Optional instance to populate.
     * @return {module:model/HydroSystemStatusExternals} The populated <code>HydroSystemStatusExternals</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new HydroSystemStatusExternals();

            if (data.hasOwnProperty('sensors')) {
                obj['sensors'] = ApiClient.convertToType(data['sensors'], [SensorData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>HydroSystemStatusExternals</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>HydroSystemStatusExternals</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of HydroSystemStatusExternals.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['sensors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['sensors'])) {
                throw new Error("Expected the field `sensors` to be an array in the JSON data but got " + data['sensors']);
            }
            // validate the optional field `sensors` (array)
            for (const item of data['sensors']) {
                SensorData.validateJSON(item);
            };
        }

        return true;
    }


}

HydroSystemStatusExternals.RequiredProperties = ["sensors"];

/**
 * Array of external sensors
 * @member {Array.<module:model/SensorData>} sensors
 */
HydroSystemStatusExternals.prototype['sensors'] = undefined;






export default HydroSystemStatusExternals;

